import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Header as Component } from '../components/header';
import styles from '../styles/desktop.css';
import type { IAccordionHeaderDepsDesktop, TAccordionHeaderDesktop } from '../models';

import { headerClassNamesHelperDesktop } from './helpers';

export const HeaderDesktop = createWidget<IAccordionHeaderDepsDesktop, TAccordionHeaderDesktop>({
    headerClassNamesHelper: headerClassNamesHelperDesktop,
    styles,
})(Component);
